__webpack_require__.p = "https://cdn.dgtalguide.com/web/bundles/fac1815/";